import { CircleX, FileTextIcon, Image, Paperclip, Sheet } from "lucide-react";
import PDFIcon from "@/assets/pdfIcon.svg";
import { toast } from "@/components/Toast";
import { cn } from "@/lib/utils";
import { useRef } from "react";

const FileInput = ({
  file,
  setFile,
  accept,
  disabled,
  maxSize, // in mb
  multiple,
  keepPreviousFiles,
  fileInputRef
}: any) => {
  let internalFileInputRef = fileInputRef ? fileInputRef : useRef<HTMLInputElement>(null);
  
  const extension = file?.name?.split(".")[1];

  const handleClick = () => {
    if (!disabled) internalFileInputRef?.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];

    if (selectedFile) {
      const fileSizeInMB = (selectedFile?.size / (1024 * 1024));
      if (maxSize && (fileSizeInMB > maxSize)) {
        // internalFileInputRef.current = null;
        toast.error(`File size should be less than ${maxSize} MB`);
      } else {
        setFile(
          multiple
            ? keepPreviousFiles
              ? [...file, ...Array.from(event.target.files || [])]
              : Array.from(event.target.files || [])
            : selectedFile
        );
        event.target.value = "";
      }
    }
  };

  return (
    <div className="flex flex-col w-full max-w-md text-start relative">
      {/* File Input Field */}
      <div
        className={cn(
          "flex items-center justify-between w-full border border-gray-300 rounded-lg px-3 py-2 cursor-pointer hover:border-gray-400 h-[40px]",
          disabled ? "cursor-not-allowed" : ""
        )}
        onClick={handleClick}
      >
        <div className="flex flex-row gap-2 items-center">
          {file?.name ? (
            extension?.includes("pdf") ? (
              <img src={PDFIcon} className="h-8 w-7" />
            ) : extension?.includes("jpeg") || extension?.includes("jpg") || extension?.includes("png")?
              <Image className="text-g-500" />
            : extension?.includes("csv") ? 
              <Sheet className="text-g-500" />
            : (
              <FileTextIcon className="text-g-500" />
            )
          ) : (
            ""
          )}
          <div className="flex flex-col">
            <span
              className={`text-gray-400 text-sm break-all line-clamp-1 ${
                file?.name ? "text-primary" : ""
              }`}
            >
              {file?.name ? file?.name : disabled ? "" : "Please attach"}
            </span>
            {file?.size && (
              <span className="text-[10px] text-g-300 -mt-1">
                size: {parseFloat((file?.size / 1024).toString()).toFixed(2)} KB
              </span>
            )}
          </div>
        </div>
        <div>
          {disabled ? (
            <></>
          ) : file?.name ? (
            <CircleX
              className={cn(
                "text-gray-400 h-5 w-5",
                disabled ? "cursor-not-allowed" : ""
              )}
              onClick={(e) => {
                if (!disabled) {
                  e.preventDefault();
                  e.stopPropagation();
                  setFile(null);
                }
              }}
            />
          ) : (
            <Paperclip className="text-gray-400 h-5 w-5" />
          )}
        </div>
      </div>

      {/* Hidden File Input */}
      <input
        type="file"
        ref={internalFileInputRef}
        className="hidden"
        onChange={handleFileChange}
        accept={accept}
        multiple={multiple}
      />
    </div>
  );
};

export default FileInput;
